import {
  CalendarOutlined,
  CopyOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { Col, Row } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ReportTreatmentStep from "../../../components/ReportTreatmentStep";
import LifeStyleModal from "./LifestyleModal";
import RegisterNewKitModal from "./RegisterNewKitModal";

const PatientTreatmentSteps = ({ patientId }) => {
  const { t } = useTranslation("common");
  const [isLifeStyleModalOpen, setIsLifeStyleModalOpen] = useState(false);
  const [isRegisterKitModalOpen, setIsRegisterKitModalOpen] = useState(false);

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} md={12} lg={8}>
        <ReportTreatmentStep
          title={t("lifeStyle")}
          stepColor="rgb(30, 58, 138)"
          step={1}
          icon={<CalendarOutlined />}
          onClick={() => setIsLifeStyleModalOpen(true)}
        />
      </Col>
      <Col xs={24} md={12} lg={8}>
        <ReportTreatmentStep
          title={t("update_visual_analysis")}
          stepColor="rgb(88, 28, 135)"
          step={2}
          icon={<UploadOutlined />}
          redirect={"analysis"}
        />
      </Col>
      <Col xs={24} md={12} lg={8}>
        <ReportTreatmentStep
          title={t("register_a_kit")}
          stepColor="rgb(20, 83, 45)"
          step={3}
          icon={<CopyOutlined />}
          onClick={() => setIsRegisterKitModalOpen(true)}
        />
      </Col>
      <LifeStyleModal
        patientId={patientId}
        isVisible={isLifeStyleModalOpen}
        onClose={() => {
          setIsLifeStyleModalOpen(false);
        }}
      />
      <RegisterNewKitModal
        isVisible={isRegisterKitModalOpen}
        onClose={() => setIsRegisterKitModalOpen(false)}
        patientId={patientId}
      />
    </Row>
  );
};

export default PatientTreatmentSteps;
